import React from 'react'
import MessageUI from '../../widgets/output/MessageUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PublicPageSF from '../../templates/PublicPageSF'
import ButtonLinkUI from '../../widgets/action/ButtonLinkUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import LoginWithEmailSF from '../../components/login/LoginWithEmailSF'
import LoginWithPhoneSF from '../../components/login/LoginWithPhoneSF'
import './HomePage.css'

const HomePageUI = ({context, messageList}) =>
  <PublicPageSF context={context} className='pg_home' centered={!messageList}>
    {
      !messageList &&
      <SpinnerComponentUI />
    }

    {
      messageList &&
      <React.Fragment>
        <PageTitleUI context={context} messageList={messageList} titleMessageKey='c_login' />
        <h4 className='g_mobile g_m_left_50 g_m_top_0'>
          <MessageUI messageList={messageList} messageKey='c_login' />
        </h4>

        {
          context.session.authMethod === 'email_password' &&
          <LoginWithEmailSF context={context} />
        }
        {
          context.session.authMethod === 'phone_pin' &&
          <LoginWithPhoneSF context={context} />
        }

        {/*
        <div className='signup g_m_top_100'>
          {
            context.session.authMethod === 'email_password' &&
            <ButtonLinkUI context={context} to='/pub/signup/e' transparent={true}
              messageList={messageList} labelKey='c_new_usr_sign_up' args={[context.session.appName]}
            />
          }
          {
            context.session.authMethod === 'phone_pin' &&
            <ButtonLinkUI context={context} to='/pub/signup/p' transparent={true}
              messageList={messageList} labelKey='c_new_usr_sign_up' args={[context.session.appName]}
            />
          }
        </div>
        */
        <div>
          <br/>
          <b>We finance climate adaptation and mitigation activities</b>
          <ul>
            <li><p><b>Renewable Energy</b> For project developers, epc contractors and installers engaged in solar wind or other renewable energy activities</p></li>
            <li><p><b>Sustainable Transportation</b> From electric vehicles to charging infrastructure and shared mobility</p></li>
            <li><p><b>Climate-Smart Food Systems</b> From drip irrigation and solar pumping to high tech weather-monitoring and harvesting</p></li>
          </ul>
          <b>Our inclusive approach to diversity</b>
          <p>Our model is focused around founder led, specifically women entrepreneur led, small and medium businesses that have limited documentation and limited access to traditional sources of capital, limited to no collateral to offer, but demonstrate good track record and growth potential. We are able to service them by assessing credit risk using our proprietary technology and deep expertise in the climate adaptation and mitigation projects. Our specific focus areas include sustainable growth of SMEs engaged in renewable energy, sustainable transport, sustainable agriculture, healthcare, and digital enterprises.</p>
        </div>
        }
      </React.Fragment>
    }
  </PublicPageSF>

export default HomePageUI
